// Added to external links
export const IDEALIST_UTM_PARAMS = {
  utm_source: 'idealist',
  utm_medium: 'referral',
};
